// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__Uqq-J","text":"styles_text__6joud","img":"styles_img__b+SBb"};